import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationBellComponent } from './shell/notification-bell/notification-bell.component';
import { AppNotification } from './services/notification.service';
import { ResetPreferencesDrawerComponent } from '../shared/reset-preferences-drawer/reset-preferences-drawer.component';
import { TransactionTerminologyPipe } from '../shared/pipes/transaction-terminology.pipe';
import { BtPrinterPickerComponent } from '../shared/bt-printer-picker/bt-printer-picker.component';

@Pipe({ name: 'unreadNotif' })
export class UnreadNotifPipe implements PipeTransform {
    transform(notifications: AppNotification[]): AppNotification[] {
        return (notifications || []).filter(n => !n.is_read);
    }
}

/**
 * SharedModule — declares and exports components used across both
 * eager (CoreModule) and lazy-loaded (MemberPortalModule) modules.
 */
@NgModule({
    declarations: [NotificationBellComponent, UnreadNotifPipe, ResetPreferencesDrawerComponent, TransactionTerminologyPipe, BtPrinterPickerComponent],
    imports: [CommonModule, TranslateModule],
    exports: [NotificationBellComponent, UnreadNotifPipe, ResetPreferencesDrawerComponent, TransactionTerminologyPipe, TranslateModule, BtPrinterPickerComponent],
})
export class SharedModule {}
